const ownLink = "https://opimisil.com/6t92PSWn";

const blogs = [
  {
    id: 1,
    date: "2024-07-25",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "New Mbm Bet 500 Bonus – How to Claim and Maximize Your Winnings",
    descr:
      "Discover how to unlock the exclusive new mbm bet 500 bonus and boost your gaming experience with special rewards.",
    fullText:
      "The new mbm bet 500 bonus is an exciting opportunity for both new and returning players to increase their chances of winning. \n\nRegister on the Mbm Bet platform and complete the verification process to become eligible for the bonus. \n\nThis bonus can be used on a variety of Mbm Bet games, from slots to live dealer experiences. \n\nBe sure to check the terms and conditions to understand the wagering requirements before withdrawing your winnings. \n\nMaximize the bonus by choosing games with a high return-to-player (RTP) percentage. \n\nTake advantage of Mbm Bet’s exclusive promotions to combine multiple bonuses and increase your overall payout. \n\nResponsible gaming is important, so always set a budget before starting your gaming session. \n\nStay updated with Mbm Bet Blog for more bonus promotions and expert gaming tips.",
  },
  {
    id: 2,
    date: "2024-07-20",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Top Strategies for Winning Big at Mbm Bet Slots",
    descr:
      "Learn expert techniques to improve your odds and enjoy higher payouts in Mbm Bet slot games.",
    fullText:
      "Slot games at Mbm Bet offer exciting themes, high-quality graphics, and rewarding bonus features. \n\nUnderstanding slot volatility is key – high volatility slots offer bigger wins, while low volatility slots provide more frequent payouts. \n\nAlways take advantage of free spins and promotions to extend your gameplay without additional investment. \n\nSetting a bankroll and sticking to it ensures you play responsibly and avoid unnecessary losses. \n\nProgressive jackpot slots are a great way to aim for massive payouts with a small wager. \n\nUtilize Mbm Bet’s demo mode to practice and find the best slots that suit your playing style. \n\nWatching for special in-game features, such as multipliers and expanding wilds, can significantly increase winnings. \n\nFollow the Mbm Bet Blog for continuous updates on the best-performing slots and upcoming game releases.",
  },
  {
    id: 3,
    date: "2024-07-15",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "Industry News: The Future of Online Betting in 2024",
    descr:
      "Discover the latest trends and innovations shaping the online betting industry and what it means for Mbm Bet players.",
    fullText:
      "Online betting has evolved rapidly, with 2024 bringing significant changes to regulations and technologies. \n\nBlockchain technology is increasing transparency in betting transactions, ensuring fair play and instant withdrawals. \n\nThe rise of AI-driven betting assistants helps players make data-driven decisions and improve their strategies. \n\nMore jurisdictions are legalizing online casinos, leading to safer and more regulated gaming environments. \n\nMobile gaming continues to dominate, with improved apps and seamless gameplay experiences. \n\nLive dealer games are becoming more interactive, offering real-time chat features and unique in-game challenges. \n\nEsports betting is seeing massive growth, attracting younger audiences and increasing market competition. \n\nMbm Bet is at the forefront of these innovations, continuously enhancing the gaming experience for its users.",
  },
  {
    id: 4,
    date: "2024-07-10",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Exclusive Mbm Bet Yono Promotions – Don’t Miss Out!",
    descr:
      "Take advantage of Mbm Bet Yono’s limited-time promotions and enjoy huge rewards.",
    fullText:
      "Mbm Bet Yono offers an exciting selection of promotions to reward loyal players and newcomers alike. \n\nLimited-time deposit bonuses provide extra cash for playing top games, maximizing your chances of winning. \n\nFree spins on selected Mbm Bet slot games let you try out new titles without risking your funds. \n\nParticipating in daily challenges and leaderboards increases your odds of securing high payouts. \n\nRegular cashback offers allow you to recover a percentage of your losses, giving you another shot at winning. \n\nJoining Mbm Bet’s VIP club unlocks additional benefits, including exclusive bonuses and priority customer support. \n\nPromotions change frequently, so checking Mbm Bet Blog ensures you never miss a great deal. \n\nSign up today and explore the best Mbm Bet Yono promotions before they expire!",
  },
  {
    id: 5,
    date: "2024-07-05",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Industry News: How AI is Changing Online Casino Gaming",
    descr:
      "Explore how artificial intelligence is revolutionizing online casino gaming and player experiences.",
    fullText:
      "Artificial intelligence (AI) is transforming online casinos by enhancing user engagement and game fairness. \n\nAI-powered algorithms analyze player behavior, providing personalized game recommendations and promotions. \n\nChatbots and virtual assistants improve customer support, offering instant responses and guidance. \n\nFraud detection systems powered by AI help identify and prevent suspicious activities on gaming platforms. \n\nDynamic odds and AI-driven analytics allow for smarter betting decisions and strategy development. \n\nLive dealer games are integrating AI to provide real-time insights, enhancing the interactive experience. \n\nGamification and adaptive learning techniques are being implemented to keep players engaged longer. \n\nMbm Bet is actively adopting AI technologies to provide a superior and more customized gaming experience.",
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;
    img.alt = data.title;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;
    img.alt = blog.title;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo") || img.closest(".santaBonus")) return;

      img.onclick = () => window.location.assign(ownLink);
    });
  }
});
